

export enum CommunicationPageTypes {
    SIGNUP = 'signup-error',
    ACCOUNT_EXISTS = 'account-exists-error',
    LOGIN = 'login-error',
    AUTH = 'auth-error',
    LOGOUT = 'logout',
}